
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"37","fill":"none","viewBox":"0 0 60 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M57.3 37H2.5C1.1 37 0 35.9 0 34.6V2.4C0 1.1 1.1 0 2.5 0h54.7c1.4 0 2.5 1 2.6 2.4v32.2c-.1 1.3-1.2 2.4-2.5 2.4zM2.5 1C1.7 1 1 1.7 1 2.4v32.2c0 .8.6 1.4 1.5 1.4h54.8c.8 0 1.5-.7 1.5-1.4V2.4c-.1-.8-.7-1.4-1.6-1.4H2.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M40.3 21.1c0-3.9-5.5-4.3-5.5-6 0-1.7 3.8-1.5 5.5-.6l.6-3.2s-1.7-.7-3.5-.7c-2 0-6.6.9-6.6 5s5.4 3.9 5.4 6-4.9 1.7-6.5.4l-.6 3.4s1.7.9 4.4.9 6.7-1.3 6.8-5.2zm3.7 5l.8-2.2h5l.5 2.2h3.5L50.7 11h-3.1c-1.4 0-1.8 1.1-1.8 1.1l-5.9 14H44zM48.1 15l1.1 5.6H46l2.1-5.6zM26.7 26.1L29.1 11h-3.9l-2.5 15.1h4zm-7.1-14.6l-3.7 10.4-.4-2.2-.2-.8-1.2-6s-.1-.6-.6-1c-.3-.2-.7-.4-1.3-.4H6l-.1.2s.8.1 2 .6c.8.3 1.8.9 2.1 1l3.3 12.8 4.2.5 6.3-15.1h-4.2z"}})])
          )
        }
      }
    